// Export components and services
export { default as AccommodationList } from './components/AccommodationList/AccommodationList.jsx';
export { default as AccommodationDetails } from './components/AccommodationDetails/AccommodationDetails.jsx';
export { accommodationService } from './services/accommodationService';

// Export constants
export {
  ACCOMMODATION_TYPES,
  ACCOMMODATION_FIELDS,
  ACCOMMODATION_STATUSES
} from './constants/accommodationTypes.ts';

// Export components
export { default as AddAccommodation } from './components/AddAccommodation/AddAccommodation.jsx';

// Import accommodationService for initialization
import { accommodationService } from './services/accommodationService';
import { backupRegistry } from '@trip-planner-monorepo/shared';
import { db } from '@trip-planner-monorepo/shared';
import { doc, setDoc } from 'firebase/firestore';

// Export initialization function
export const initAccommodationServices = () => {
  // Register backup capabilities with the backup registry
  backupRegistry.register('accommodation', {
    fetchAll: async (userId, tripId) => {
      console.log(`[Accommodation] Fetching all accommodations for backup: userId=${userId}, tripId=${tripId}`);
      return await accommodationService.fetchAccommodation(userId, tripId);
    },
    restoreAll: async (userId, tripId, data) => {
      console.log(`[Accommodation] Restoring ${data.length} accommodations for trip ${tripId}`);

      // Data is an array of accommodation documents from backup
      for (const accomData of data) {
        try {
          // Preserve original ID by using setDoc instead of addDoc
          const accomRef = doc(db, 'users', userId, 'trips', tripId, 'accommodation', accomData.id);

          // Remove the id from the data object (it's already in the document reference)
          const { id, ...accomDataWithoutId } = accomData;

          // Use setDoc to create/overwrite document with preserved ID
          await setDoc(accomRef, {
            ...accomDataWithoutId,
            updatedAt: new Date().toISOString()
          });

          console.log(`[Accommodation] Restored accommodation ${accomData.id} (${accomData.name || accomData.type})`);
        } catch (error) {
          console.error(`[Accommodation] Error restoring accommodation ${accomData.id}:`, error);
          throw error;
        }
      }

      console.log(`[Accommodation] Successfully restored ${data.length} accommodations`);
    },
    version: '1.0'
  });

  console.log('[Accommodation] Registered with backup registry');

  // Initialize the accommodation service
  accommodationService.init();
  console.log('Accommodation services initialized');
};